import { createContext } from 'react'

export interface Auth {
  authed: boolean
  roles: string[]
  signIn: (token: string) => void
  signOut: () => void
  hasRole: (...roles: string[]) => boolean
}

export const AuthContext = createContext<Auth | null>(null)
